var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewsEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#171719"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_3796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6472 25.6895H16.2941C16.2842 25.7469 16.278 25.7958 16.2668 25.844C15.668 28.4147 15.0689 30.9853 14.4691 33.5556C14.2574 34.4637 13.3722 35.0752 12.3913 34.9923C11.4318 34.9111 10.6893 34.1659 10.6502 33.2431C10.6459 33.1407 10.6472 33.0384 10.6472 32.9358C10.6472 30.611 10.6472 28.2859 10.6472 25.9611V25.6898V25.6895Z",
    fill: "#858B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1765 21.8369V16.1788C34.1765 15.9131 34.4563 15.7383 34.6981 15.8534C35.6637 16.3126 36.5398 17.6582 36.5997 18.9177C36.6609 20.2049 35.7955 21.6202 34.7024 22.1603C34.4606 22.2796 34.1765 22.1045 34.1765 21.8369Z",
    fill: "#858B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6102 14.0665C10.2975 14.0671 9.98015 14.0965 9.67293 14.1539C7.13609 14.6285 5.39105 16.9545 5.63546 19.5227C5.87271 22.0159 8.05157 23.969 10.606 23.9716C12.8444 23.9739 16.8575 23.9729 18.6633 23.9723C19.1743 23.9723 19.5883 23.5618 19.5883 23.0555V14.9797C19.5883 14.4734 19.1743 14.0629 18.6633 14.0629C16.8584 14.0623 12.8489 14.0617 10.6102 14.0665Z",
    fill: "#858B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9325 13.5694L31.413 8.09473C31.9758 7.8025 32.6418 8.22183 32.6402 8.86708L32.5884 29.4822C32.5868 30.1298 31.9144 30.5452 31.353 30.2458L21.9246 24.6463C21.6458 24.4974 21.4706 24.2026 21.4706 23.8808L21.47 14.3395C21.47 14.0141 21.649 13.7167 21.9325 13.5694Z",
    fill: "#858B9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_3796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27,
    fill: "white",
    transform: "translate(5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewsEvents);
export default __webpack_public_path__ + "static/media/icon-news-events.783dac9b51964e0c9d7c63606d51b63e.svg";
export { ForwardRef as ReactComponent };